const {
  REACT_APP_BACKEND_URL,
  REACT_APP_NODE_ENV,
  REACT_APP_DEFAULT_QUIZMASTER,
  REACT_APP_DEFAULT_QUESTION_REGION,
  REACT_APP_GENERAL_CATEGORY_ID,
} = process.env;

module.exports.config = {
  backendUrl: REACT_APP_BACKEND_URL,
  nodeEnv: REACT_APP_NODE_ENV,
  defaultQuizmaster: REACT_APP_DEFAULT_QUIZMASTER,
  defaultQuestionRegion: REACT_APP_DEFAULT_QUESTION_REGION,
  generalCategoryId: REACT_APP_GENERAL_CATEGORY_ID,
};
